import { getThemeSiteFromDomain, getUserRoleFromDomain } from "./theme/utils";

export const userRole = getUserRoleFromDomain();
export const site = getThemeSiteFromDomain();
